import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import './App.css';
import { supabase } from './lib/supabaseClient';
import Home from './pages/home/home';
import Dashboard from './pages/dashboard/dashboard';
import Payments from './pages/payments/payments';
import SleepCareCheckout from './pages/checkout/SleepCareCheckout';

/**
 * Supabase 세션을 기준으로 인증 검증.
 * - 'checking': 세션 조회 진행 중 (깜빡임 방지로 빈 화면 유지)
 * - 'yes': 세션 있음 → children 렌더
 * - 'no': 세션 없음 → 홈으로 redirect
 *
 * 새 탭/북마크/홈 화면 아이콘으로 직접 진입해도 정상 통과.
 */
function PrivateRoute({ children }) {
  const [authState, setAuthState] = useState('checking');

  useEffect(() => {
    let cancelled = false;
    supabase.auth
      .getSession()
      .then(({ data }) => {
        if (cancelled) return;
        setAuthState(data?.session ? 'yes' : 'no');
      })
      .catch(() => {
        if (cancelled) return;
        setAuthState('no');
      });
    /** 토큰 갱신/로그아웃 등 세션 변동도 즉시 반영 */
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      if (cancelled) return;
      setAuthState(session ? 'yes' : 'no');
    });
    return () => {
      cancelled = true;
      sub?.subscription?.unsubscribe?.();
    };
  }, []);

  if (authState === 'checking') return null;
  if (authState === 'no') return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <Router basename="/somnia-sleepcare">
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/checkout" element={<SleepCareCheckout />} />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/payments"
            element={
              <PrivateRoute>
                <Payments />
              </PrivateRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
